import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import MobileLeftSection from "../../Components/MobileLeftSection";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import { FaBookReader } from "react-icons/fa";
import { MdOutlineMenuBook } from "react-icons/md";
import { BookJson } from "./BookModel";
import { useSelector } from "react-redux";
import { Book_Details } from "../../Action/BookDemoAction";
import { useNavigate } from "react-router-dom";
import { FaReadme } from "react-icons/fa6";
import Lock from "../../Components/Lock";

export default function MobileBook() {
  const [SideOpener, setSideOpner] = useState(false);
  const dispatch = useDispatch();
  const { bookDet, loading, error } = useSelector(
    (s) => s.Book_Details_Reducer
  );
  const Navigate = useNavigate();
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(Book_Details());
  }, [dispatch]);
  return (
    <>
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} Page="Books" />
        <div className="main-content">
          <MobileHeaderSection Page="Books" OpenSideMenu={OpenSideMenu} />
          <div className="Books_Reader" style={{ padding: "20px" }}>
            {bookDet ? (
              <div class="books-container">
                {BookJson?.map((ev, i) => (
                  <div
                    class="book-card"
                    data-book={i + 1}
                    key={i + 890}
                    onClick={() => Navigate(`/student/book/${ev?.BookName}`)}
                  >
                    {/* <div class="book-header">
                     <h3 class="book-title">
                       {ev?.BookName?.replaceAll("-", " ")}
                     </h3>
                     <span class="book-status">Available</span>
                   </div> */}

                    <div class="book-cover-section">
                      <img
                        src={
                          process.env.REACT_APP_DOC + "/Books/" + ev?.Book_Cover
                        }
                        alt="The Adventure Begins"
                        class="book-cover-img"
                      />
                      {/* <span className="e-book">E-BOOK</span> */}
                    </div>
                    <h3 class="book-title">
                      {ev?.BookName?.replaceAll("-", " ")}
                    </h3>

                    <div class="book-meta">
                      {/* <div class="meta-item">
                        <span class="meta-icon">📄</span>
                        <span class="meta-text">{ev?.Pages} pages</span>
                      </div> */}
                      {/* <div class="meta-item">
                        <span class="meta-icon">⭐</span>
                        <span class="meta-text">{ev?.Rating} rating</span>
                      </div> */}
                    </div>

                    <button
                      class="action-btn primary"
                      onClick={() => Navigate(`/student/book/${ev?.BookName}`)}
                    >
                      <span>Read Book</span>
                      <span class="btn-icon" style={{ marginTop: "8px" }}>
                        <FaReadme />
                      </span>
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div>
                <Lock />
              </div>
            )}
          </div>
          <MobileBottomMenu Page="Books" />
        </div>
      </div>
    </>
  );
}
